import React from 'react'
import Subheader from '../../../component/Subheader'
import OtherRoom from '../../RoomDetail/OtherRoom';
import RoomBanner from '../../RoomDetail/RoomBanner';
import RoomQuote from '../../RoomDetail/RoomQuote';
import RoomCount from '../../RoomDetail/RoomCount';
import RoomGallery from '../../RoomDetail/RoomGallery';
import RoomEquipment from '../../RoomDetail/RoomEquipment';
import RoomBook from '../../RoomDetail/RoomBook';

export default function GoaSuperdeluxe() {
    const heading = "Super Deluxe Room";

    const subheadData = {
        heading: (
                    <>
                    <span className="sr-only">Goa Room</span> {heading}
                    </>
                ),
        breadcrumb: [
            {
                slug: "/resort-de-coracao-goa/room-listing",
                name: (
                        <>
                        <span className="sr-only">{heading}</span> Rooms
                        </>
                    ),
            },
            {
                slug: "",
                name: "Super Deluxe Room",
            },
        ]
    }

    const roomBanner = {
        image: "/image/goa-super-deluxe-room-detail.webp",
    };

    const roomQuote = {
        content: "Traveling with a small family or your best friends? The Super Deluxe gives you that extra bit of flexibility. With enough room to add an extra mattress comfortably, nobody feels cramped. It’s a stylish, upgraded space where you can lounge, chat, and enjoy the slower pace of Goan life together.",
    };

    const roomCount = {
        bedroom: "1",
        bedsize: "1",
        area: "28",
        bathroom: "1",
        guest: "3",
        balcony: "1"
    };

    const roomGallery = [
        { image: "/image/goa-super-deluxe-room-gallery-1.webp" },
        { image: "/image/goa-super-deluxe-room-gallery-2.webp" },
        { image: "/image/goa-super-deluxe-room-gallery-3.webp" },
        { image: "/image/goa-super-deluxe-room-gallery-4.webp" },
        { image: "/image/goa-super-deluxe-room-gallery-5.webp" },
    ];

    const roomEquipment = {
        description: "Discover a comfortable retreat with well-designed interiors and thoughtful amenities that add ease to every moment of your stay.",
        equipment: [
        [
            "Bidet & Premium Mirror",
            "Extra space for an additional guest mattress",
            "Hydropneumatic pressure showers for a spa-like feel",
            "Evening Turndown service to welcome you back",
        ],
        [
            "Fully stocked Tea/Coffee maker",
            "42-inch Entertainment Hub (LED TV)",
            "Dedicated Writing Desk & Electrical Outlets",
            "In-Room Electronic Safe",
        ],
        [
            "Mini-Refrigerator for snacks",
            "High-quality Hair Dryer & Vanity Mirror",
            "All-day Room Service",
            "Stay connected with free Wi-Fi",
            "Ironing Board available for crisp evening wear",
        ]
    ]
    };

    const roomBook = {
        location: "Goa",
        title: "Super Deluxe Room",
        desc: "Make your Goa getaway more comfortable in the Super Deluxe Room, offering generous space for families and friends. With thoughtful amenities, a relaxing ambience, and room for an additional mattress, it combines convenience and comfort for a carefree stay.",
        details: [
            "1 King Size Bed + 1 Extra Mattress ",
            "Up to 3 Guests",
            "28 sq mt"
        ],
        enquireLink: "/contact-us",
        bookLink: "https://www.swiftbook.io/inst/#home?propertyId=963MjgsolW0h7uc1ZijJxO0lkzsqHF2oUxvyvlueoPaIL0TFw8FUwK5Ng==&JDRN=Y"
    };


    const otherRoom = {
        slides: [
            {
                title: 'Premium Room',
                bg: '/image/goa-other-room-1.webp',
                slug: '/resort-de-coracao-goa/premium-room',
                details: [
                    "1 King Bed + 1 Extra Mattress ",
                    "Up to 3 Guests",
                    "30 sq mt",
                ],
            },

            {
                title: 'Suite Room',
                bg: '/image/goa-other-room-3.webp',
                slug: '/resort-de-coracao-goa/suite-room',
                details: [
                    "1 King Size Bed + Living Room Seating",
                    "3 Guests",
                    "37 sq.mt",
                ],
            },

            {
                title: 'Standard Room',
                bg: '/image/goa-other-room-6.webp',
                slug: '/resort-de-coracao-goa/standard-room',
                details: [
                    "1 King Size Bed",
                    "2 Guests",
                    "21 sq. mt",
                ],
            },

            {
                title: 'Deluxe Room',
                bg: '/image/goa-other-room-2.webp',
                slug: '/resort-de-coracao-goa/deluxe-room',
                details: [
                    "1 King Size",
                    "2 Guests",
                    "24 sq mt",
                ],
            },
        ],

        allRoom: { link: "/resort-de-coracao-goa/room-listing" }
    }

    return (
        <>
            <Subheader subheadData={subheadData} />
            <RoomBanner roomBanner={roomBanner} />
            <RoomQuote roomQuote={roomQuote} />
            <RoomCount roomCount={roomCount} />
            <RoomGallery roomGallery={roomGallery} />
            <RoomEquipment roomEquipment={roomEquipment} />
            <RoomBook roomBook={roomBook} />
            <OtherRoom otherRoom={otherRoom} roomTitle={`${roomBook.location} ${subheadData.heading}`}/>
        </>
    )
}
